import React from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { Grid, Popup, Icon, Button } from 'semantic-ui-react';

import POSKeyboardInput from 'PointOfSale/modules/common/component/KeyboardInput';
import POSButton from 'PointOfSale/modules/common/component/Button';
import PortalOverlay from 'PointOfSale/modules/common/component/PortalOverlay';
import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';
import { TransactionTypeEnum } from 'Common/Constants/Enumeration/TransactionTypeEnum';

const getIcon = transactionType => {
  switch (transactionType) {
    case TransactionTypeEnum.Check:
      return { icon: 'book', color: 'teal' };
    case TransactionTypeEnum.Credit:
      return { icon: 'credit card', color: 'olive' };
    case TransactionTypeEnum.Cash:
      return { icon: 'money', color: 'green' };
    case TransactionTypeEnum.Charge:
      return { icon: 'exchange', color: 'purple' };
    default:
      return '';
  }
};

const getButton = (
  option,
  onclick,
  disabled = false,
  showCheck = false,
  creditCardEnabled = true
) => {
  const buttonOptions = getIcon(option.value);
  const isCreditCardButton = option.value === TransactionTypeEnum.Credit;
  if (isCreditCardButton && creditCardEnabled === false) {
    return null;
  }

  return (
    <Button
      fluid
      compact
      size="big"
      onClick={onclick}
      disabled={disabled}
      loading={disabled}
      color={buttonOptions.color}
    >
      <Button.Content>
        {option.type === 'Check' && showCheck ? (
          <Icon.Group>
            <Icon name="square" />
            {showCheck && <Icon name={'check'} color={'green'} />}
          </Icon.Group>
        ) : (
          <Icon name={buttonOptions.icon} />
        )}
        {option.type}
      </Button.Content>
    </Button>
  );
};

const PaymentOptionsComponent = ({
  paymentOptions,
  onClickHandler,
  onCheckNumber,
  onAmountPaid,
  isOpen,
  handleOpen,
  handleClose,
  checkNumber,
  amountPaid,
  disabled,
  onCheckInputFocus,
  onCheckInputBlur,
  onAmountFocus,
  onAmountBlur,
  checkPopupId,
  onAmountTabPress,
  forwardedRefs,
  creditCardEnabled,
  keyboardActive,
}) => {
  return _.map(paymentOptions, (option, index) => {
    return option.type === 'Check' ? (
      <React.Fragment key={index}>
        <Grid.Column mobile={4} largeScreen={4} className="text-end strong">
          <Popup
            id={checkPopupId}
            trigger={getButton(
              option,
              handleOpen,
              disabled,
              checkNumber && checkNumber.length > 0
            )}
            on="click"
            open={isOpen}
            onClose={handleClose}
            position="top center"
            flowing
            size="large"
            offset={keyboardActive ? '0px, 190px' : undefined}
            basic={keyboardActive}
          >
            <Popup.Content>
              <div>
                <label className="text-left">Amount Paid</label>
                <POSKeyboardInput
                  icon="dollar"
                  iconPosition="left"
                  placeholder="Amount Paid"
                  onChange={onAmountPaid}
                  value={amountPaid}
                  usePortal
                  onBlur={onAmountBlur}
                  onFocus={onAmountFocus}
                  layoutType={LAYOUT_TYPES.NUMERIC}
                  forwardedRef={forwardedRefs[0]}
                  onTabPress={onAmountTabPress}
                />
                <label className="text-left">Check Number</label>
                <POSKeyboardInput
                  icon="hashtag"
                  iconPosition="left"
                  placeholder="Check Number"
                  onChange={onCheckNumber}
                  value={checkNumber}
                  usePortal
                  onFocus={onCheckInputFocus}
                  onBlur={onCheckInputBlur}
                  forwardedRef={forwardedRefs[1]}
                />
              </div>

              <div style={{ marginTop: 25 }}>
                <POSButton
                  label="Submit"
                  selected
                  fluid
                  disabled={disabled}
                  onClick={() => {
                    onClickHandler && onClickHandler(option.value);
                  }}
                />
              </div>
            </Popup.Content>
          </Popup>
        </Grid.Column>
        {isOpen && (
          <PortalOverlay
            modalRoot={document.getElementById('main-container-id')}
            divClassName={'opacityPoint2'}
          />
        )}
      </React.Fragment>
    ) : (
      <Grid.Column
        key={index}
        mobile={4}
        largeScreen={4}
        className="text-end strong"
      >
        {getButton(
          option,
          () => {
            if (!disabled) {
              onClickHandler && onClickHandler(option.value);
            }
          },
          disabled,
          false,
          creditCardEnabled
        )}
      </Grid.Column>
    );
  });
};

PaymentOptionsComponent.propTypes = {
  paymentOptions: PropTypes.array.isRequired,
  keyboardActive: PropTypes.bool.isRequired,
  onClickHandler: PropTypes.func.isRequired,
  onCheckNumber: PropTypes.func.isRequired,
  onAmountPaid: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  checkNumber: PropTypes.string.isRequired,
  amountPaid: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCheckInputFocus: PropTypes.func.isRequired,
  onCheckInputBlur: PropTypes.func.isRequired,
  onAmountFocus: PropTypes.func.isRequired,
  onAmountBlur: PropTypes.func.isRequired,
  checkPopupId: PropTypes.string.isRequired,
  onAmountTabPress: PropTypes.func.isRequired,
  forwardedRefs: PropTypes.array.isRequired,
  creditCardEnabled: PropTypes.bool.isRequired,
};

export default PaymentOptionsComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/PaymentOptionsComponent.js